export default {
    disclaimer: {
        label_default: "Je reconnais et j'accepte que les articles que je commande / reçois sont la propriété de O-I et doivent être utilisés pour des activités liées au travail, et à ce titre, O-I se réserve le droit de demander la restitution de ces biens lors de mon départ de O-I (ou plus tôt, si O-I l'exige).",
        label_type_1: "Je confirme que l'auto-évaluation relative au télétravail a été remplie avec exactitude et de bonne foi, et que tout équipement ou mobilier fourni par les locaux de O-I ou commandé via Gear sera utilisé par moi-même dans le cadre de mon travail pour O-I. Je reconnais et j'accepte que les articles que je commande/reçois sont la propriété de O-I et doivent être utilisés pour des activités professionnelles liées à O-I. Par conséquent, O-I se réserve le droit d'en demander la restitution à mon départ de O-I (ou plus tôt, si O-I l'exige).",
        errors: {
            required: "Veuillez accepter les conditions d'utilisation"
        }
    },
    cost_center: {
        label: "Code du centre de coûts",
        placeholder: "Code du centre de coûts",
        cost_center_not_found: "L'affichage des centres de coûts absents peut prendre jusqu'à 24 heures. Veuillez contacter le service d'assistance global si vous ne trouvez pas le centre de coûts approprié.",
        errors: {
            regex: "Code de centre de coûts invalide"
        }
    },
    company_code: {
        label: "Code de l'entreprise"
    },
    cost_center_name: {
        label: "Nom du centre de coûts"
    },
    order_note: {
        label: "Note de commande",
        placeholder: "Note facultative à l'attention du responsable pour approbation",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Veuillez me tenir informé(e) des mises à jour concernant cette commande"
    },
    "dell_banner":{
        label: "En raison de mises à jour des systèmes Dell, les commandes passées entre le 1er et le 14 août 2026 pourraient subir d'importants retards de traitement. Veuillez prévoir des délais de livraison plus longs pendant cette période. Nous vous remercions de votre compréhension."
    }
}